import { FrameworkConfiguration, PLATFORM } from 'aurelia-framework';

//Load styles
require("@rightship-tech/rs-inspections-ui/styles/core.scss");

export function configure(config: FrameworkConfiguration) {

    //Aurelia plugins
    config.plugin(PLATFORM.moduleName('aurelia-validation')); 
    config.plugin(PLATFORM.moduleName('aurelia-ui-virtualization')); 

    //Load global resources
    config.globalResources([

        //Drawer
        PLATFORM.moduleName("./views/drawer/inspection-details-drawer"),

        //Partials
        PLATFORM.moduleName("./views/partials/inspection-report/partial-rightship-inspection-report"),
        PLATFORM.moduleName("./views/partials/customer-findings/partial-rightship-inspection-customer-findings")
    ]);

    //Load plugins
    config.plugin(PLATFORM.moduleName("@rightship-tech/common-ui"));
}